// Pixel Meta : chargé uniquement si un ID est configuré ET si le visiteur a accepté les cookies publicitaires.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CONSENT_KEY = 'ledzone_cookie_consent';
const FBCLID_KEY = 'ledzone_fbclid';
const FIRED_KEY = 'ledzone_meta_purchases';

let pixelId = null;
let loaded = false;
let configKnown = false;
let lastHref = null;
let pending = [];

export const newEventId = () => (crypto.randomUUID ? crypto.randomUUID()
  : Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join(''));

export const getConsent = () => { try { return localStorage.getItem(CONSENT_KEY); } catch { return null; } };
export const hasConsent = () => getConsent() === 'granted';

export const setConsent = (value) => {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* stockage indisponible */ }
  window.dispatchEvent(new CustomEvent('ledzone-consent', { detail: value }));
  if (value === 'granted') loadPixel();
};

const loadPixel = () => {
  if (loaded || !pixelId || !hasConsent()) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
  s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', pixelId);
  loaded = true;
  lastHref = null;
  pageView();
  pending.forEach(([n, p, id]) => window.fbq('track', n, p, { eventID: id }));
  pending = [];
};

export const trackMeta = (name, params = {}, eventId = newEventId()) => {
  if (loaded && window.fbq) window.fbq('track', name, params, { eventID: eventId });
  else if (!configKnown && hasConsent()) pending.push([name, params, eventId]);
  return eventId;
};

const pageView = () => {
  const href = window.location.pathname + window.location.search;
  if (href === lastHref) return;
  lastHref = href;
  trackMeta('PageView');
};

const readCookie = (name) => document.cookie.split('; ').find((c) => c.startsWith(`${name}=`))?.split('=')[1];

// Contexte envoyé au serveur (API Conversions). Sans consentement : uniquement consent=false.
export const metaContext = (eventId) => {
  if (!hasConsent()) return { consent: false, event_source_url: window.location.href };
  let fbc = readCookie('_fbc');
  if (!fbc) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(FBCLID_KEY) || 'null');
      if (saved) fbc = `fb.1.${saved.ts}.${saved.id}`;
    } catch { /* ignoré */ }
  }
  return { consent: true, event_id: eventId, fbp: readCookie('_fbp') || null, fbc: fbc || null, event_source_url: window.location.href };
};

export const trackPurchaseOnce = (p) => {
  if (!p?.eligible || !p.event_id) return;
  let fired = [];
  try { fired = JSON.parse(localStorage.getItem(FIRED_KEY) || '[]'); } catch { fired = []; }
  if (fired.includes(p.event_id) || !hasConsent() || (configKnown && !loaded)) return;
  trackMeta('Purchase', { value: p.value, currency: 'CHF', order_id: p.order_id, content_ids: p.content_ids, content_type: 'product', num_items: p.num_items }, p.event_id);
  try { localStorage.setItem(FIRED_KEY, JSON.stringify([...fired, p.event_id].slice(-50))); } catch { /* ignoré */ }
};

export const initMeta = async () => {
  try {
    const id = new URLSearchParams(window.location.search).get('fbclid');
    if (id) sessionStorage.setItem(FBCLID_KEY, JSON.stringify({ id, ts: Date.now() }));
  } catch { /* ignoré */ }
  ['pushState', 'replaceState'].forEach((m) => {
    const orig = window.history[m];
    window.history[m] = function patched(...args) { const r = orig.apply(this, args); if (loaded) setTimeout(pageView, 0); return r; };
  });
  window.addEventListener('popstate', () => loaded && pageView());
  try {
    const r = await fetch(`${BACKEND_URL}/api/meta/config`);
    pixelId = (await r.json()).pixel_id || null;
  } catch { pixelId = null; }
  configKnown = true;
  loadPixel();
  if (!loaded) pending = [];
};
